import img1 from "../assets/Madam Sofowora.jpg";
import img2 from "../assets/Ms Alamutu.jpg";
import img3 from "../assets/Mr FusiAkinkungbe.jpg";
import img4 from "../assets/Mr Anthony Ebele .JPG";
import img6 from "../assets/Dare Osoneye.JPG";
import img7 from "../assets/Babafunke .jpg";

const teamData = [
  {
    id: "olapeju-sofowora",
    name: "Olapeju Sofowora B.SC, FCA, FCIT",
    role: "Principal Consultant",
    shortBio:
      "Principal Consultant with about 40 years experience in audit, tax, corporate finance, and advisory services. Passionate about governance and professional development.",
    image: img1,
    fullBio: `
Olapeju E. Sofowora is the Founding Partner of ABAX Professional Services, bringing about 40 years of experience across audit, tax, corporate finance, and professional advisory services.

She began her career at Coopers & Lybrand (now PricewaterhouseCoopers), later held senior roles in the banking sector, and went on to establish and lead multiple professional services practices, including serving as Partner and Managing Partner at Abax-OOSA Professionals for over 17 years. Her passion for quality professional services led her to establish Binary Consulting Limited, a Human Resources Consulting firm specialising in recruitment, outsourcing and training for clients across different industries.

Olapeju is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN) and the Chartered Institute of Taxation of Nigeria (CITN), a Certified Information Systems Auditor (CISA), and holds a degree in Statistics from the University of Ilorin.

She has served on corporate and institutional boards, including First City Monument Bank Group, Royal Trust Assurance Limited, Olashore International School Association, the Educational Committee of the Chartered Institute of Taxation, and as an Executive Committee Member of the Money Market Association of Nigeria.
    `,
  },
  {
    id: "ayo-alamutu",
    name: "Ayo Alamutu B.SC FCA CISA CIRM ORE",
    role: "Senior Consultant Governance and Risk",
    shortBio:
      "Governance, risk, audit, and compliance executive with 30+ years of experience across UK and Nigeria. Supports boards on operational resilience and risk management.",
    image: img2,
  },
  {
    id: "babafunke-ajibade",
    name: "Babafunke Ajibade B.SC FCA CPFA",
    role: "Senior Consultant Audit and Assurance",
    shortBio:
      "Multi-skilled Governance, Financial Accounts, and Audit professional with 30+ years experience in Nigeria and UK. Specializes in risk, compliance, and internal audit.",
    image: img7,
  },
  {
    id: "fusi-akinkugbe",
    name: "Fusi Akinkugbe BSC FCA",
    role: "Senior Consultant Financial Services",
    shortBio:
      "Finance and assurance professional with nearly 40 years experience in consulting, corporate leadership, and professional services. Expertise in governance and organizational effectiveness.",
    image: img3,
  },
  {
    id: "anthony-ebele",
    name: "Anthony Ebele (HND ACTI)",
    role: "Head, Tax Management and Advisory",
    shortBio:
      "Specialist in tax advisory and management for corporate clients.",
    image: img4,
  },
  {
    id: "Dare-osoneye",
    name: "Dare Osoneye (BSc, MSc, CIPM, SHRM-CP, ACIPM)",
    role: "Head, Human Resources Consulting",
    shortBio:
      "HR consulting expert specializing in recruitment, outsourcing, and training.",
    image: img6,
  },
];

export default teamData;
